export default __webpack_public_path__ + "static/media/warning.47295309.svg";